import React from 'react';
import { useQuery } from '@apollo/client';
import { FormGroup, FormWrapper, FormCell } from '../FormStructure';
import { ERROR_MESSAGE } from '../Messages/Messages';
import { LOGGED_IN_MENU_QUERY } from './operations';
import LoggedInMenuDynamic from './LoggedInMenuDynamic';
import AccountNavMenuLinks from './AccountNavMenuLinks';
import SignOutButton from './SignOutButton';
import { TmntText } from '../Common';
import { LoggedInMenuPropTypes, LoggedInMenuDefaultProps } from './props';
import { ACCOUNT_NAV_RECS_TARGET_ID } from './constants';

export default function LoggedInMenu({ isMobileView }) {
  const { loading, error, data = {} } = useQuery(LOGGED_IN_MENU_QUERY);

  if (error) return ERROR_MESSAGE;

  const { textFor = {} } = data;

  const handleMyAbercrombie = (url) => {
    const brand = window?.digitalData?.get('page.brand') || 'anf';
    const brandRewardsPage = brand === 'hol' ? 'HollisterHouseRewards' : 'MyAbercrombie';

    const pageFMUrl = url.includes('?')
      ? `${url}&pagefm=navigation+-+${brandRewardsPage}`
      : `${url}?pagefm=navigation+-+${brandRewardsPage}`;

    window.location.assign(pageFMUrl);
  };

  // Determine loading state - only show loading for static data that's not cached
  const isLoading = loading && !textFor;

  // Render account navigation links
  const renderAccountNavLinks = (links) => links?.map((section) => (
    <AccountNavMenuLinks
      key={section?.label?.value || 'nav-section'}
      links={section?.options}
      onMyAbercrombieClick={handleMyAbercrombie}
      isMobileView={isMobileView}
      isLoggedIn
    />
  ));

  return (
    <div className="logged-in-menu" data-testid={!isLoading ? 'logged-in-menu' : 'logged-in-menu--loading'}>
      <FormWrapper>
        <FormGroup>
          {/* Entry point for the dynamic logged in data */}
          <LoggedInMenuDynamic text={textFor} />
          <FormCell isLoading={isLoading}>
            { textFor?.accountNavMenuLinks && renderAccountNavLinks(textFor.accountNavMenuLinks) }
          </FormCell>
          {/* Target for the account nav recommendation sliders */}
          <div id={ACCOUNT_NAV_RECS_TARGET_ID} />
          <FormCell isLoading={isLoading}>
            {
              textFor?.signOutButtonText && (
                <SignOutButton>
                  <TmntText
                    tmnt={textFor?.signOutButtonText}
                    testId="logged-in-menu-signout"
                  />
                </SignOutButton>
              )
            }
          </FormCell>
        </FormGroup>
      </FormWrapper>
    </div>
  );
}

LoggedInMenu.propTypes = LoggedInMenuPropTypes;
LoggedInMenu.defaultProps = LoggedInMenuDefaultProps;
